/**
 * Shows a user-visible fallback when the compatibility widget script fails to load.
 */
function initCompatibilityToolFallbacks() {
  const widgetScript = document.querySelector(
    '[data-compatibility-tool-script]'
  )
  if (!widgetScript) return

  document.querySelectorAll('[data-compatibility-tool]').forEach((root) => {
    const errorEl = root.querySelector('[data-compatibility-tool-error]')
    const skeleton = root.querySelector('.compatibility-tool-skeleton')

    if (!errorEl) return

    widgetScript.addEventListener('error', () => {
      errorEl.hidden = false
      if (skeleton) skeleton.hidden = true
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCompatibilityToolFallbacks)
} else {
  initCompatibilityToolFallbacks()
}
